import React, {Fragment} from 'react'
import { Link } from 'react-router-dom'
import Slider from 'react-slick';
import { resolveCaseStudyDetailSlug } from '../../constants/projectCaseStudies'
import { SLICK_BREAKPOINT_KEY } from '../../constants/slickBreakpoints'

/** @typedef {{ img?: string, imgSrc?: string, tag: string, title: string, desc: string, icon: string, thumbClassName?: string }} CaseSlideItem */

/** 소프트웨어 개발·구축 사례 상세 교차 노출용 — 블록체인 생태계 */
export const CASE_SLIDER_BLOCKCHAIN_ITEM = {
    imgSrc: '/assets/img/work/flc-rwa-ecosystem.png',
    thumbClassName: 'case-thumb--slot-410x450',
    detailSlug: 'blockchain-ecosystem',
    tag: 'Web3 / 플랫폼',
    title: '블록체인 생태계 웹·앱 구축',
    desc: '비공개 클라이언트: NFT·실물자산 연계·스테이킹·로드맵을 아우르는 반응형 랜딩과 관리자·모바일 UI까지 일관된 브랜드 경험으로 구축.',
    icon: 'bi bi-arrow-up-right',
}

/** 소프트웨어 개발·구축 사례 상세 교차 노출용 — B2C 이커머스 */
export const CASE_SLIDER_B2C_ECOMMERCE_ITEM = {
    imgSrc: '/assets/img/work/b2c-mall-main-landing.png',
    thumbClassName: 'case-thumb--slot-410x450',
    detailSlug: 'b2c-ecommerce-platform',
    tag: '이커머스 / 플랫폼',
    title: '통합 온라인 쇼핑몰 플랫폼 구축',
    desc: '메인·베스트·이벤트·카테고리 내비와 상품 그리드, 푸터까지 일체형 랜딩. 검색·장바구니·회원 동선을 고려한 B2C 몰 UI를 구축했습니다.',
    icon: 'bi bi-arrow-up-right',
}

/** Premium Auto Concierge — Mercedes-Benz Korea · KCC Auto */
export const CASE_SLIDER_PREMIUM_AUTO_CONCIERGE_ITEM = {
    imgSrc: '/assets/img/work/premium-auto-concierge-landing.png',
    thumbClassName: 'case-thumb--slot-410x450',
    detailSlug: 'premium-auto-concierge',
    tag: '자동차 / 컨시어지',
    title: '프리미엄 오토 컨시어지(PAC) 웹·CRM 구축',
    desc: 'pac.codam.co.kr — 공식 세일즈 컨설턴트 1:1 상담, 프로모션·라인업·견적·예약·회원·CRM 관리자까지 프리미엄 브랜드 웹·운영 콘솔 구축 사례입니다.',
    icon: 'bi bi-arrow-up-right',
}

/** 디지털 자산·거래소 웹 플랫폼 개발 */
export const CASE_SLIDER_DIGITAL_ASSETS_EXCHANGE_ITEM = {
    imgSrc: '/assets/img/work/digital-assets-exchange-landing.png',
    thumbClassName: 'case-thumb--slot-410x450',
    detailSlug: 'digital-assets-exchange-platform',
    tag: '핀테크 / 거래 플랫폼',
    title: '디지털 자산 거래 플랫폼 개발',
    desc: '랜딩과 스팟 거래 UI에 더해 자산·출금·이체·계정 보안 화면까지 묶은 거래소 웹 제품 개발 사례입니다. 모바일·태블릿 반응형까지 포함했습니다.',
    icon: 'bi bi-arrow-up-right',
}

/** B2C 몰 Android·iOS 네이티브 앱 구축 사례 */
export const CASE_SLIDER_B2C_MOBILE_ITEM = {
    imgSrc: '/assets/img/work/b2c-mall-mobile-home.png',
    thumbClassName: 'case-thumb--slot-410x450',
    detailSlug: 'b2c-mall-mobile-apps',
    tag: '이커머스 / 네이티브 앱',
    title: 'B2C몰 앱 개발 (Android·iOS)',
    desc: '동일 몰 서비스의 Android·iOS 앱으로 홈·탐색·장바구니·결제까지 한 손 동선을 설계하고, 푸시·스토어 배포까지 포함한 네이티브 구축 사례입니다.',
    icon: 'bi bi-arrow-up-right',
}

/** @type {CaseSlideItem[]} */
export const CASE_SLIDER_DEFAULT_ITEMS = [
    {
        img: 'case-1b',
        tag: '제조 / ERP',
        title: '제조 기업 ERP 연동 통합 플랫폼',
        desc: '기존 ERP 시스템과 연동되는 실시간 생산 현황 대시보드 및 발주·재고 관리 통합 플랫폼 개발. 업무 처리 시간 40% 단축.',
        icon: 'bi bi-arrow-up-right',
    },
]

/**
 * 구축 사례 상세: 블록체인 ↔ B2C 이커머스가 서로 첫 슬라이드로 연결되도록
 * @param {string | null | undefined} canonicalSlug CASE_STUDIES 키
 * @returns {CaseSlideItem[] | null}
 */
export function getCaseSliderItemsForDetailSlug(canonicalSlug) {
    if (canonicalSlug === 'premium-auto-concierge') {
        return [
            CASE_SLIDER_DIGITAL_ASSETS_EXCHANGE_ITEM,
            CASE_SLIDER_BLOCKCHAIN_ITEM,
            CASE_SLIDER_B2C_ECOMMERCE_ITEM,
        ]
    }
    if (canonicalSlug === 'blockchain-ecosystem') {
        return [
            CASE_SLIDER_DIGITAL_ASSETS_EXCHANGE_ITEM,
            CASE_SLIDER_B2C_ECOMMERCE_ITEM,
            CASE_SLIDER_B2C_MOBILE_ITEM,
        ]
    }
    if (canonicalSlug === 'digital-assets-exchange-platform') {
        return [CASE_SLIDER_BLOCKCHAIN_ITEM, CASE_SLIDER_B2C_ECOMMERCE_ITEM, CASE_SLIDER_B2C_MOBILE_ITEM]
    }
    if (canonicalSlug === 'b2c-ecommerce-platform') {
        return [
            CASE_SLIDER_DIGITAL_ASSETS_EXCHANGE_ITEM,
            CASE_SLIDER_BLOCKCHAIN_ITEM,
            CASE_SLIDER_B2C_MOBILE_ITEM,
        ]
    }
    if (canonicalSlug === 'b2c-mall-mobile-apps') {
        return [
            CASE_SLIDER_DIGITAL_ASSETS_EXCHANGE_ITEM,
            CASE_SLIDER_B2C_ECOMMERCE_ITEM,
            CASE_SLIDER_BLOCKCHAIN_ITEM,
        ]
    }
    return null
}

const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 3,
    slidesToScroll: 1,
    [SLICK_BREAKPOINT_KEY]: [
         {
            breakpoint: 991,
            settings: { slidesToShow: 2 }
        }, {
            breakpoint: 575,
            settings: { slidesToShow: 1, arrows: false }
        }
    ]
};

/**
 * @param {{ items?: CaseSlideItem[] }} [props]
 */
const CaseSliderOne = (props = {}) => {
    const { items } = props
    const list = items == null ? CASE_SLIDER_DEFAULT_ITEMS : items

    return (
        <Fragment>
            <Slider {...settings} className="row gx-0 px-0 case-slider-one" data-aos="fade-up" data-aos-delay={200}>
                {list.map((val, i)=> {
                    const detailTo = `/project-details/${resolveCaseStudyDetailSlug(val)}`
                    return (
                    <div key={i} className="col-lg-4">
                        <div className="case-item-one">
                            <div className={`case-thumb${val.thumbClassName ? ` ${val.thumbClassName}` : ''}`}>
                                <img
                                    className={val.thumbClassName ? undefined : 'w-100'}
                                    src={val.imgSrc ?? `/assets/img/work/${val.img}.jpg`}
                                    alt={`${val.title} 구축 사례`}
                                    loading="lazy"
                                    decoding="async"
                                />
                            </div>
                            <div className="case-content">
                                <span>{val.tag}</span>
                                <h3>
                                    <Link className="sect-title-two" to={detailTo}>{val.title}</Link>
                                </h3>
                                <p>{val.desc}</p>
                                <Link className="case-btn" to={detailTo}><i className={val.icon}/></Link>
                            </div>
                        </div>
                    </div>
                    )
                })}
            </Slider>
        </Fragment>
    )
}

export default CaseSliderOne
